/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export const SORTIERRICHTUNG = {
    AUFSTEIGEND: "AUFSTEIGEND",
    ABSTEIGEND: "ABSTEIGEND",
} as const;

type Sortierrichtung = keyof typeof SORTIERRICHTUNG;

export default Sortierrichtung;